import { render, staticRenderFns } from "./baubeschreibung.vue?vue&type=template&id=3a92e6d8&"
import script from "./baubeschreibung.vue?vue&type=script&lang=js&"
export * from "./baubeschreibung.vue?vue&type=script&lang=js&"
import style0 from "./baubeschreibung.vue?vue&type=style&index=0&id=3a92e6d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports